import { ID } from '../../utils/codecUtils';
import { emailThreadSchema } from '../models/emailThreads.schema';

export const get = (emailId: ID) => {
  return {
    endpoint: `email_threads/${emailId}`,
    method: 'GET',
    responseSchema: emailThreadSchema,
  } as const;
};
